(function () {
  const CONTENT_RATIO = 0.8;

  const calcDurationScroll = (slides) => {
    switch (slides.length) {
      case 1:
        return "bottom bottom";
      case 2:
        return "+=100%";
      case 3:
        return "+=175%";
      case 4:
        return "+=225%";
      case 5:
        return "+=250%";
    }
  };

  const initStepsAnim = () => {
    const containers = document.querySelectorAll(".steps");

    containers.forEach((elem) => {
      // Kill only this element's ScrollTriggers before reinit
      ScrollTrigger.getAll()
        .filter((st) => st.vars.trigger === elem)
        .forEach((st) => st.kill());

      const removeWheelHandler = () => {
        if (elem._stepsWheelHandler) {
          elem.removeEventListener("wheel", elem._stepsWheelHandler);
          elem._stepsWheelHandler = null;
        }
      };

      ScrollTrigger.matchMedia({
        "(min-width: 990px)": function () {
          removeWheelHandler();

          const slides = elem.querySelectorAll(".steps__slide-item--desktop");
          const scrollContainer = elem.querySelector(".steps__scroll");
          const images = Array.from(
            elem.querySelectorAll(".steps__scroll .steps__image")
          );

          if (!slides.length) return;

          let currentIndex = 0;
          let isAnimating = false;
          let pendingIndex = -1;
          const DURATION = 0.6;

          const snapPoints = Array.from({ length: slides.length }, (_, i) =>
            slides.length > 1 ? (i / (slides.length - 1)) * CONTENT_RATIO : 0
          );

          const activateSlide = (index) => {
            slides.forEach((slide, i) => {
              slide.classList.remove("active", "prev");
              if (i < index) slide.classList.add("prev");
            });
            slides[index].classList.add("active");
          };

          const goToSlide = (index) => {
            if (index < 0 || index >= slides.length) return;

            if (isAnimating) {
              if (index !== currentIndex) pendingIndex = index;
              return;
            }

            if (index === currentIndex) return;

            isAnimating = true;
            pendingIndex = -1;
            currentIndex = index;
            activateSlide(currentIndex);

            const onComplete = () => {
              isAnimating = false;
              if (pendingIndex !== -1 && pendingIndex !== currentIndex) {
                const next = pendingIndex;
                pendingIndex = -1;
                goToSlide(next);
              }
            };

            if (scrollContainer && images[currentIndex]) {
              gsap.to(scrollContainer, {
                y: -images[currentIndex].offsetTop,
                duration: DURATION,
                ease: "power2.inOut",
                onComplete,
              });
            } else {
              setTimeout(onComplete, DURATION * 1000);
            }
          };

          const resetToFirst = () => {
            currentIndex = 0;
            isAnimating = false;
            pendingIndex = -1;
            activateSlide(0);
            gsap.set(scrollContainer, { y: 0 });
          };

          activateSlide(0);
          gsap.set(scrollContainer, { y: 0 });

          let st = null;
          let wheelAccumulator = 0;
          let lastTriggerTime = 0;
          const TRIGGER_COOLDOWN = 800;

          elem._stepsWheelHandler = (e) => {
            if (!st || !st.isActive) return;

            const direction = e.deltaY > 0 ? 1 : -1;

            // At boundaries — let page scroll naturally
            if (direction > 0 && currentIndex >= slides.length - 1) return;
            if (direction < 0 && currentIndex <= 0) return;

            e.preventDefault();

            if (isAnimating) {
              wheelAccumulator = 0;
              return;
            }

            // Cooldown prevents Safari momentum from triggering next slide
            const now = Date.now();
            if (now - lastTriggerTime < TRIGGER_COOLDOWN) {
              wheelAccumulator = 0;
              return;
            }

            // Trackpad (pixel mode) — accumulate until intentional swipe
            if (e.deltaMode === 0) {
              wheelAccumulator += e.deltaY;
              if (Math.abs(wheelAccumulator) < 60) return;
            }
            // Mouse wheel (line/page mode) — one detent is enough

            wheelAccumulator = 0;
            lastTriggerTime = now;

            const nextIndex = currentIndex + direction;
            const stickyHeader = document.querySelector("sticky-header");
            if (stickyHeader)
              stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));

            goToSlide(nextIndex);

            const targetScroll =
              st.start + (st.end - st.start) * snapPoints[nextIndex];
            window.scrollTo(0, targetScroll);
          };

          elem.addEventListener("wheel", elem._stepsWheelHandler, {
            passive: false,
          });

          st = ScrollTrigger.create({
            trigger: elem,
            start: "top top",
            end: calcDurationScroll(slides),
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            snap: {
              snapTo: snapPoints,
              duration: { min: 0.1, max: 0.3 },
              ease: "power2.inOut",
              delay: 0,
            },
            onUpdate: (self) => {
              // Skip when wheel handler is controlling animation (prevents Safari scroll bounce from setting wrong pendingIndex)
              if (isAnimating) return;
              const relativeProgress =
                slides.length > 1
                  ? Math.min(self.progress / CONTENT_RATIO, 1)
                  : self.progress;
              const newIndex = Math.round(
                relativeProgress * (slides.length - 1)
              );
              goToSlide(newIndex);
            },
          });
        },
        "(max-width: 989px)": function () {
          removeWheelHandler();

          const scrollEl = elem.querySelector(".steps__scroll");
          if (scrollEl) {
            gsap.killTweensOf(scrollEl);
            gsap.set(scrollEl, { clearProps: "transform" });
          }

          // Reset slide states for mobile
          elem
            .querySelectorAll(".steps__slide-item--desktop")
            .forEach((slide, i) => {
              slide.classList.remove("prev");
              if (i === 0) slide.classList.add("active");
              else slide.classList.remove("active");
            });
        },
      });
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      initStepsAnim();
    }, 300);
  });

  document.addEventListener("shopify:section:load", function () {
    setTimeout(() => {
      initStepsAnim();
    }, 300);
  });

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initStepsAnim();
    }, 200);
  });
})();
